module.exports = __webpack_public_path__ + "media/images/application/template/icon--map-marker_smaller-53174eafaa5083267d53331ae79b86a5.svg";